export default {
  active: 'Override de ngtorch ativo: {ref} ({sha})',
  activeBranch: 'Override de ngtorch ativo: commit mais recente de {ref}',
  reinstalling: '· reinstalando metadados do pacote',
  manage: 'Gerenciar',
  disable: 'Desativar'
}
